export const COMPANY = {
  name: "Mohr Engineering Limited",
  short: "Mohr Engineering",
  tagline: "We Build Experiences",
  descriptor: "Turnkey Projects & General Contracting",
  location: "House 123, 12th Crescent, Kado Estate, Abuja, Nigeria",
  phones: ["+234 703 333 8313", "+234 703 644 4347", "+234 803 658 8884"],
  emails: ["info@mohrengineeringnigeria.com", "engr.mohr@yahoo.com"],
  website: "www.mohrengineeringnigeria.com",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "What We Do", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Leadership", to: "/leadership" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    code: "01",
    title: "Geotechnical Investigations",
    short: "Ground truth before steel rises.",
    body: "Site characterisation, soil mechanics, foundation recommendation, slope stability and seismic response — so every structure sits on evidence, not assumption.",
    image: "/projects/jabi-basement.jpg",
    deliverables: ["Soil testing & classification", "Boreholes & CPT", "Foundation design inputs", "Ground improvement strategy"],
  },
  {
    code: "02",
    title: "Civil Engineering Design & Consultancy",
    short: "Drawings that build themselves.",
    body: "Structural, civil and MEP design coordinated on one federated model — resolving constructability, cost and code long before the first blockwork goes up.",
    image: "/projects/shore-07.jpg",
    deliverables: ["Structural calculations", "Reinforced concrete & steel design", "Drainage & hydraulics", "Construction documentation"],
  },
  {
    code: "03",
    title: "Civil Engineering Works",
    short: "Execution, owned end-to-end.",
    body: "Earthworks, concrete, structural steel, timber, and pre-cast / pre-stressed concrete — delivered with our own site teams and cost discipline from day one.",
    image: "/projects/shore-01.jpg",
    deliverables: ["Substructure & superstructure", "Site infrastructure", "Roads & drainage", "Water supply systems"],
  },
  {
    code: "04",
    title: "Design · Build · Maintain",
    short: "A single accountability.",
    body: "Turnkey project delivery with one contract, one programme and one team — from concept, through commissioning, to long-term asset maintenance.",
    image: "/projects/shagaya-main-01.jpg",
    deliverables: ["Turnkey delivery", "Preconstruction management", "Fit-out & commissioning", "Facility maintenance"],
  },
];

export const VALUES = [
  { k: "Integrity", v: "We say what we will do, and we do what we say — even when no one is watching." },
  { k: "Precision", v: "Tolerances are not negotiable. Neither is our finish quality." },
  { k: "Safety", v: "Zero harm is the only acceptable outcome on any Mohr site." },
  { k: "Stewardship", v: "We build for the communities, climates and clients who will live with the result." },
];

export const LEADERSHIP = [
  {
    name: "Engr. Mohammed Tahir Abdulsalam",
    role: "CEO / Managing Director",
    bio: "A chartered engineer with more than two decades of field-led leadership across turnkey civil, institutional and residential projects. Sets the technical and ethical standard for every Mohr delivery.",
    initials: "MT",
    accent: "#BE1E2D",
  },
  {
    name: "Maryam Mohammed Abdulsalam",
    role: "Director",
    bio: "Directs corporate governance, strategic partnerships and institutional relationships. Leads the firm's commitment to diversity, sustainability and client experience.",
    initials: "MA",
    accent: "#004B87",
  },
  {
    name: "Zainab Mohammed Abdulsalam",
    role: "Director",
    bio: "Oversees business development and client engagement. Shapes how Mohr Engineering translates client ambition into delivered project outcomes.",
    initials: "ZA",
    accent: "#006838",
  },
  {
    name: "Johnson A. Abidoye",
    role: "Contract & Project Manager",
    bio: "Runs commercial management, programme control and supplier performance across active sites. The calm point of contact when a project needs to accelerate.",
    initials: "JA",
    accent: "#0A0A0A",
  },
  {
    name: "Augustina Okafor",
    role: "Client Relations",
    bio: "First voice for every client inquiry. Ensures responsiveness, clarity and continuity from first conversation to handover.",
    initials: "AO",
    accent: "#BE1E2D",
  },
];

export const CLIENTS = [
  "Nigeria Customs Service",
  "BILAAD Realty",
  "7 Fifteen Capital",
  "Visivo Dettaglio",
  "Shvistov Farms",
  "Archivisual Solutions",
  "FCT Water Board",
  "Sim Shagaya",
];

export const GALLERY_IMAGES = [
  "/projects/shore-01.jpg",
  "/projects/shore-02.jpg",
  "/projects/shagaya-main-01.jpg",
  "/projects/ncs-accommodation.jpg",
  "/projects/shore-03.jpg",
  "/projects/shagaya-majlis-01.jpg",
  "/projects/shore-04.jpg",
  "/projects/jabi-basement.jpg",
  "/projects/shore-05.jpg",
  "/projects/gwagwalada-road.jpg",
  "/projects/shore-06.jpg",
  "/projects/residential-01.jpg",
  "/projects/shore-07.jpg",
  "/projects/gwagwalada-water.jpg",
  "/projects/shore-08.jpg",
  "/projects/residential-02.jpg",
  "/projects/shore-09.jpg",
];

export const PROCESS_STEPS = [
  { code: "01", title: "Discover", body: "We listen first. Site visits, stakeholder workshops, and brief interrogation — so scope, cost and programme start from reality." },
  { code: "02", title: "Design", body: "Integrated design across civil, structural and MEP. Constructability and cost are reviewed every step of the way." },
  { code: "03", title: "Deliver", body: "Self-performed civil works, tightly managed subcontractors and weekly client reporting. No surprises at handover." },
  { code: "04", title: "Sustain", body: "Post-handover snagging, defects liability and long-term asset maintenance to protect the investment." },
];
